import useMediaQuery from '@eversports/klimt-design-components/use-media-query'

/**
 * Returns whether the user asked their system to reduce motion, so that decorative animations can
 * be shown in their resting state instead of looping.
 * @see https://developer.mozilla.org/en-US/docs/Web/CSS/@media/prefers-reduced-motion
 */
const usePrefersReducedMotion = () => useMediaQuery('(prefers-reduced-motion: reduce)')

export default usePrefersReducedMotion
